import { gql } from '@urql/core';

import { funnelsFeatureKeys, funnelFragment } from './queries';
import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';

export const createFunnelMutation = ({ client, queryClient }) => ({
  mutationFn: ({ siteId, name, visitStep, goalSteps }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation FunnelCreate($siteId: Int!, $name: String!, $visitStep: Boolean!, $goalSteps: [Int]!) {
          funnelCreate(siteId: $siteId, name: $name, visitStep: $visitStep, goalSteps: $goalSteps) {
            ...funnel
          }
        }
        ${funnelFragment}
      `,
      {
        siteId,
        name,
        visitStep,
        goalSteps,
      },
    ),
  onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: funnelsFeatureKeys.funnelList._def });
  },
});

export const editFunnelMutation = ({ client, queryClient }) => ({
  mutationFn: ({ id, siteId, name, visitStep, goalSteps }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation FunnelEdit($id: Int!, $siteId: Int!, $name: String!, $visitStep: Boolean!, $goalSteps: [Int]!) {
          funnelEdit(id: $id, siteId: $siteId, name: $name, visitStep: $visitStep, goalSteps: $goalSteps) {
            ...funnel
          }
        }
        ${funnelFragment}
      `,
      {
        id,
        siteId,
        name,
        visitStep,
        goalSteps,
      },
    ),
  onSuccess: (_, variables) => {
    queryClient.invalidateQueries({ queryKey: funnelsFeatureKeys.funnelList._def });
    queryClient.removeQueries({
      ...funnelsFeatureKeys.funnelDetail({ id: variables.id }),
    });
  },
});

export const editFunnelNameMutation = ({ client, queryClient }) => ({
  mutationFn: ({ id, siteId, name }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation FunnelEditName($id: Int!, $siteId: Int!, $name: String!) {
          funnelEditName(id: $id, siteId: $siteId, name: $name) {
            ...funnel
          }
        }
        ${funnelFragment}
      `,
      {
        id,
        siteId,
        name,
      },
    ),
  onSuccess: (_, variables) => {
    queryClient.invalidateQueries({ queryKey: funnelsFeatureKeys.funnelList._def });
    queryClient.removeQueries({
      ...funnelsFeatureKeys.funnelDetail({ id: variables.id }),
    });
  },
});

export const deleteFunnelMutation = ({ client, queryClient }) => ({
  mutationFn: ({ ids }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation FunnelDelete($ids: [Int!]!) {
          funnelDelete(ids: $ids) {
            affected
          }
        }
      `,
      {
        ids,
      },
    ),
  onSuccess: (data) => {
    queryClient.invalidateQueries({ queryKey: funnelsFeatureKeys.funnelList._def });
    data.funnelDelete.affected.forEach((id) => {
      queryClient.invalidateQueries({
        ...funnelsFeatureKeys.funnelDetail({ id }),
        refetchType: 'none',
      });
    });
  },
});
